import { Label, LabeledControl, Switch } from '@zillow/constellation-10';

type Props = {
  text: string;
  onClick: () => void;
  toggled: boolean | null;
  disabled?: boolean;
};

export default function SwitchWithTitle({ text, onClick, toggled, disabled }: Props): JSX.Element {
  return (
    <LabeledControl
      size="lg"
      labelPosition="right"
      disabled={disabled}
      label={<Label data-test="subheader">{text}</Label>}
      control={<Switch onClick={disabled ? undefined : onClick} checked={toggled ?? false} disabled={disabled} />}
    />
  );
}
